import { z } from "zod";
import {
  cursorPaginatedResponseSchema,
  DateSchema,
  EmailSchema,
  IdSchema,
  IsActiveSchema,
  NameSchema,
  NonNegativeNumber,
  PhoneSchema,
} from "./commonSchema";
import type { CursorPaginatedResponse } from "@/types/common";

export const UserSchema = z.object({
  id: IdSchema,
  email: EmailSchema,
  name: NameSchema,
  phone: PhoneSchema.nullish(),
  workshopId: IdSchema,
  isActive: IsActiveSchema,
  isRoot: z.boolean().default(false),
  createdBy: IdSchema.nullish(),
  createdAt: DateSchema,
  createdByName: NameSchema.nullish(),
  updatedAt: DateSchema,
  deletedAt: DateSchema.nullish(),
  deletedBy: IdSchema.nullish(),
  deletedByName: NameSchema.nullish(),
});

export type User = z.infer<typeof UserSchema>;

export const UserListItemSchema = UserSchema.pick({
  id: true,
  email: true,
  name: true,
  phone: true,
  isActive: true,
  isRoot: true,
  createdAt: true,
  deletedAt: true,
  createdByName: true,
});

export type UserListItem = z.infer<typeof UserListItemSchema>;

export const UserStatsSchema = z.object({
  totalTransactions: z.coerce.number().int().min(0),
  totalWeightHandled: NonNegativeNumber,
  totalLaborBilled: NonNegativeNumber,
  totalDepositCollected: NonNegativeNumber,
  lastTransactionAt: z.string().nullable(),
});

export type UserStats = z.infer<typeof UserStatsSchema>;

export const CreateUserSchema = UserSchema.pick({
  email: true,
  name: true,
  phone: true,
  isActive: true,
});

export type CreateUser = z.infer<typeof CreateUserSchema>;

export type UserListResponse = CursorPaginatedResponse<UserListItem>;

export const UserListResponseSchema = cursorPaginatedResponseSchema(UserListItemSchema);
